<template>
  <div class="d-table">
    <Table
      border
      :columns="columns1"
      :data="tableData"
      :span-method="spanMethod"
    >
      <template slot-scope="{ row }" slot="checkVisit">
        <span v-html="row.checkVisit"></span>
      </template>
    </Table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(["dicts"]),
  },
  watch: {
    info(newValue, oldValue) {
      this.init();
    },
  },
  data() {
    return {
      columns1: [
        {
          title: "项目分类",
          key: "checkVisitTypeStr",
          width: 100,
        },
        {
          title: "项目",
          key: "checkVisit",
          slot: "checkVisit",
        },
        {
          title: "得分",
          key: "score",
          width: 80,
        },
      ],
      tableData: [],
    };
  },
  methods: {
    spanMethod({ row, column, rowIndex, columnIndex }) {
      //  合并第一列
      let l = this.tableData.length;
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: l,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    setTableData() {
      this.tableData = [];
      let dList = this.dicts["BH_DOCTOR_CHECK"];
      this.info.checkInfo.forEach((item) => {
        if (item.score < 0) {
          this.tableData.push({
            checkVisitTypeStr: this.info.checkVisitTypeStr,
            checkVisit: `${this.common.valueToLabel(dList, item.id)}（${
              item.isMVS == "1"
                ? "<span class='text-red'>不合格</span>"
                : "提醒"
            }）`,
            score: item.score,
          });
        }
      });
    },
    init() {
      this.setTableData();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.d-table {
}
</style>